import { InjectionToken } from '@angular/core';

export const LUMILOGIN_URL = new InjectionToken<string>('LUMILOGIN_URL')
export const LUMILOGIN_REALM = new InjectionToken<string>('LUMILOGIN_REALM')
export const LUMILOGIN_CLIENTID = new InjectionToken<string>('LUMILOGIN_CLIENTID')
export const LUMILOGIN_SECRET = new InjectionToken<string>('LUMILOGIN_SECRET')
export const APPLICATION_NAME = new InjectionToken<string>('APPLICATION_NAME')
